import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import axios from '@/common/axios'

import moment from 'moment'

const SET_ROUND = 'SET_ROUND'
const LOGOUT_USER = 'LOGOUT_USER'

//console.log('createLedger: '+ ADD_CARTRULES)

const round_obj = {
    namespaced: true,
    state: {
        round: []
    },
    mutations: {
        SET_ROUND (state, data) {
            state.round = data
        },
        LOGOUT_USER (state) {
            state.round = []
        }
    },
    getters: {
        round (state) {
            return state.round
        }
    },
    actions: {
        // API Calls
        async getAllRound ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                //console.log('getAllRound data: ', data)
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('round',)
                //console.log('getAllRound response: ', response)

                let reformatRound = {}
                for (let key in response.data) {
                    //console.log('ROUND', key, this.allRound[key])
                    reformatRound[key] = {}

                    if ( key == 'goves' && response.data[key].length > 0 ) {
                        reformatRound[key] = response.data[key][0] // goverment lotto should be open just one round

                        let start_date = new Date(reformatRound[key].start_date)
                        reformatRound[key].start = start_date.getTime()
                        reformatRound[key].startTime = moment(reformatRound[key].start_date).format('HH.mm')

                        let end_date = new Date(reformatRound[key].expiration_date)
                        reformatRound[key].end = end_date.getTime()
                        reformatRound[key].endTime = moment(reformatRound[key].expiration_date).format('HH.mm')


                    }
                    else if ( key == 'indexes' && response.data[key].length > 0 ) {
                        //console.log('key', key)
                        let close_round = response.data['indexes_close_round']

                        for (let j = 0; j < response.data[key].length; j++) {
                            let round = response.data[key][j].round
                            let round_id = response.data[key][j].id

                            reformatRound[key][round] = response.data[key][j]

                            let start_date = new Date(reformatRound[key][round].start_date)
                            reformatRound[key][round].start = start_date.getTime()
                            reformatRound[key][round].startTime = moment(reformatRound[key][round].start_date).format('HH.mm')

                            let end_date = new Date(reformatRound[key][round].expiration_date)
                            reformatRound[key][round].end = end_date.getTime()
                            reformatRound[key][round].endTime = moment(reformatRound[key][round].expiration_date).format('HH.mm')


                            let startTime = reformatRound[key][round].startTime
                            let [shh, smm] = startTime.split('.')

                            let start_time = new Date()

                            start_time.setHours(shh, smm, 0) // open time 01.00 or 17.30

                            reformatRound[key][round].start_time  = start_time

                            let endTime = reformatRound[key][round].endTime
                            let [ehh, emm] = endTime.split('.')


                            if ( close_round.length > 0 ) {
                                let isClose = close_round.includes( round_id )
                                //console.log('close_round', round_id, isClose)
                                if ( isClose ) {
                                    reformatRound[key][round].status = 0
                                }
                            }
                            

                            //check fix round
                            if ( round == '1' ) {
                                //US
                                let curr_time = new Date()

                                //ISO day of the week with 1 being Monday and 7 being Sunday.
                                let weekday = moment(curr_time).format('E')
                                //console.log('weekday', weekday)

                                let start_time = new Date()
                                start_time.setHours(17, 30, 0)

                                if ( curr_time < start_time ) {
                                    // current time is 00.01 - 17.29 < 17.30
                                    let yesterday = new Date()
                                    yesterday.setDate(yesterday.getDate() - 1)
                                    reformatRound[key][round].start_time  = yesterday.setHours(shh, smm, 0)

                                    let today = new Date()
                                    reformatRound[key][round].end_time   = today.setHours(ehh, emm, 0)

                                    //let usa_closed = reformatRound[key][round].status
                                    //console.log('usa_close', usa_closed)

                                    if ( weekday == 1 ) {
                                        // Monday, not open between 00.01-17.30
                                        reformatRound[key][round].status = 0
                                    }
                                    else if ( weekday == 6 ) {
                                        // Saturday, still open between 00.01-02.00
                                        reformatRound[key][round].status = 1
                                    }

                                }
                                else {
                                    //current time is 17.31 - 23.59 > 01.00
                                    let tomorrow = new Date()
                                    tomorrow.setDate(tomorrow.getDate() + 1)

                                    reformatRound[key][round].end_time  = tomorrow.setHours(ehh, emm, 0)
                                }

                            }
                            else if ( round == '25' || round == '26' ) {

                                
                                let start_date = new Date(reformatRound[key][round].start_date)
                                reformatRound[key][round].start_time = start_date.getTime()
                                
                                let end_date = new Date(reformatRound[key][round].expiration_date)
                                reformatRound[key][round].end_time = end_date.getTime()

                                //console.log('round', round, moment(reformatRound[key][round].expiration_date).format('DD-MM-YYY HH.mm'))
                                
                            }
                            else {

                                let curr_time = new Date()
                                if ( curr_time < start_time ) {
                                    // current time is 00.01 - 00.59 < 01.00

                                    let yesterday = new Date()
                                    yesterday.setDate(yesterday.getDate() - 1)

                                    reformatRound[key][round].end_time  = yesterday.setHours(ehh, emm, 0)

                                }
                                else {
                                    //current time is 01.01 - 23.59 > 01.00
                                    let today = new Date()
                                    reformatRound[key][round].end_time   = today.setHours(ehh, emm, 0)
                                }

                                // console.log('xx', round, reformatRound[key][round].description, moment(reformatRound[key][round].start_time).format('DD/MM/YYYY HH:mm:ss'), moment(reformatRound[key][round].end_time).format('DD/MM/YYYY HH:mm:ss'))

                            }
                            // end check fix round

                        }


                    }
                    else if ( key == 'yeekees' && response.data[key].length > 0 ) {
                        for (let j = 0; j < response.data[key].length; j++) {
                            let round = response.data[key][j].round
                            reformatRound[key][round] = response.data[key][j]

                            let start_date = new Date(reformatRound[key][round].start_date)
                            reformatRound[key][round].start = start_date.getTime()
                            reformatRound[key][round].startTime = moment(reformatRound[key][round].start_date).format('HH.mm')

                            let end_date = new Date(reformatRound[key][round].expiration_date)
                            reformatRound[key][round].end = end_date.getTime()
                            reformatRound[key][round].endTime = moment(reformatRound[key][round].expiration_date).format('HH.mm')
                        }
                    } 
                    else {
                        reformatRound[key] = response.data[key]
                    }                   
                }
                //console.log('getAllRound reformatRound: ', reformatRound)
                commit(SET_ROUND, reformatRound)
                return reformatRound
                //return response.data
            } catch (error) {
                throw new Error(error)
            }
        },

        async getRound ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                //console.log('getRound data: ', data)
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('round', {params: {lottotype_id: data.lottotype_id,}})
                //console.log('getRound response: ', response.data)
                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },

        async getRoundGOVByRoundId ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                //console.log('getRoundByRoundId data: ', data)
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('round/' + data)
                //console.log('getRoundGOVByRoundId: ', response.data)
                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },

        async getRoundYeekeeByRoundId ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                //console.log('getRoundByRoundId data: ', data)
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('round/yeekee/' + data)
                //console.log('getRoundYeekeeByRoundId: ', response.data)

                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },

        async getRoundIndexeskByRoundId ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                //console.log('getRoundByRoundId data: ', data)
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('round/indexes/' + data)
                //console.log('getRoundIndexeskByRoundId: ', response.data)
                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },

        async getYeekeeByRoundId ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                //console.log('getYeekeeByRoundId data: ', data)
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('round/yeekee_round/' + data)
                //console.log('getYeekeeByRoundId: ', response.data)

                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },

        async getIndexesByRoundId ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                //console.log('getIndexesByRoundId data: ', data)
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('round/index_round/' + data)
                //console.log('getIndexesByRoundId: ', response.data)
                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },

        async getRoundByType ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                //console.log('getLottoResultByType data: ', data)
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('round/showroundbytype/' + data)
                // console.log('getRoundByType: ', response.data)
                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },

        // Only Mutations
        async userLogout ({ dispatch, commit, getters, rootGetters }) {
            try {
                commit(LOGOUT_USER)
            } catch (error) {
                throw new Error(error)
            }
        },
    }
}

export default round_obj
